import jQuery from 'jquery';
import AhaDrawer from 'javascripts/drawer';

export function getReportReferenceFromUrl(url: string | undefined) {
  if (!url) {
    return null;
  }

  let urlParts = url.split('/');
  // Remove any blank parts from the URL
  urlParts = urlParts.filter(part => part.length > 0).reverse();

  // Get the last id from the URL if it matches the pattern
  if (url.match(/bookmarks\/custom_pivots\/\d+(?:\/\d+)?/)) {
    // This is a custom pivot URL, extract
    const lastPart = urlParts.find(part => part.match(/(\d+)/));
    const match = lastPart?.match(/(\d+)/)?.[0];

    if (match) {
      return `Report-${match}`;
    }
  }

  return null;
}

export function getReferenceNumFromUrl(url: string | undefined) {
  if (!url) {
    return null;
  }
  let urlParts = url.split('/');
  // Remove any blank parts from the URL
  urlParts = urlParts.filter(part => part.length > 0);
  const foundRef = urlParts
    .reverse()
    .find(part => part.match(/[a-zA-Z0-9]+-\d+/));

  if (foundRef) {
    // strip any query params and # fragments
    const cleanRef = foundRef.split(/[?#.]/)[0];
    return cleanRef;
  }

  const reportRef = getReportReferenceFromUrl(url);
  if (reportRef) {
    return reportRef;
  }

  return null;
}

export function getReferenceNumsOfSelectedRecords() {
  return Array.from(document.querySelectorAll('aha-card[selected]'))
    .map(el => {
      const url = el.getAttribute('data-drawer-url');
      if (url) {
        return getReferenceNumFromUrl(url);
      }
      return null;
    })
    .filter(Boolean);
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class AssistantContext {
  static #instance: AssistantContext;
  private constructor() {}
  public static get instance(): AssistantContext {
    if (!AssistantContext.#instance) {
      AssistantContext.#instance = new AssistantContext();
    }

    return AssistantContext.#instance;
  }

  context: Record<string, any> = {};

  pushAssistantContextChanged() {
    const event = new CustomEvent('aha-assistant:context-changed', {
      detail: this.context,
    });

    window.dispatchEvent(event);
  }

  setReferences(references: string[]) {
    // Replace all references with the new array
    this.context.references = references;
    this.pushAssistantContextChanged();
  }

  removeReferenceFromContext(reference?: string) {
    if (reference && this.context.references) {
      // Remove specific reference from array
      this.context.references = this.context.references.filter(
        (ref: string) => ref !== reference
      );
    } else {
      this.context.references = [];
    }

    this.pushAssistantContextChanged();
  }
}

function handleSelectionChanged() {
  if (AhaDrawer?.isOpen?.()) {
    return;
  }

  handleLocationChange();
}

function handleLocationChange() {
  const referenceNum = getReferenceNumFromUrl(window.location.pathname);
  const referenceNums = getReferenceNumsOfSelectedRecords();
  if (referenceNum && !referenceNums.includes(referenceNum)) {
    referenceNums.push(referenceNum);
  }
  AssistantContext.instance.setReferences(referenceNums);
}

// Listen for page changes (Turbolinks navigation)
jQuery(document).on('page:change', handleLocationChange);

// Listen for browser back/forward navigation
window.addEventListener('popstate', handleLocationChange);
window.addEventListener('aha-record:selection:changed', handleSelectionChanged);

// Listen for custom events that may change the location
document.addEventListener('aha.redirect_to', function () {
  // NOTE: this event is dispatched before the url changes, so we need to wait a tick
  setTimeout(handleLocationChange, 0);
});

export default AssistantContext;
